import React from 'react'
import { Link } from 'react-router-dom'
import MessageUI from './MessageUI'
import './Tab.css'

const TabLinkUI = ({messageList, labelKey, label, to, active}) =>
  <Link to={to} className={`w_tab g_muted ${active ? 'active' : ''}`}>
    {
      label &&
      <span className='g_no_wrap'>{label}</span>
    }
    {
      !label &&
      <MessageUI messageList={messageList} messageKey={labelKey} />
    }
  </Link>

export default TabLinkUI
